<template>
  <div>
    <div class="mt-2 border border-zt-dark-300 rounded px-2 pt-1 relative" id="documents-search-digitalformsfilter">
      <label class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8">{{
        $t("message.eforms.digitalForms") }}</label>
      <div>
        <MultiSelect :value="eformSelected" @input="setEformSelected" :options="eformOpts" :searchable="true"
          label="name" :multiple="true" :internal-search="true" :clear-on-select="true" :close-on-select="false"
          :preserve-search="false" :show-labels="false" :show-no-options="false" placeholder="" track-by="id">
          <template slot="noResult"><span class="multiselect__single">{{
            $t('message.searchComponent.not_founded')
              }}</span></template>
          <template slot="maxElements"><span class="multiselect__single">{{
            $t('message.searchComponent.max_elements')
              }}</span></template>
          <template #tag="{ remove, option }">
            <CustomChip @click="remove(option)">{{ option.name }}</CustomChip>
          </template>
        </MultiSelect>
      </div>
    </div>
    <div class="flex pt-4">
      <div class="flex-1">
        <div class="pr-1">
          <v-menu ref="menuStart" v-model="datePickerStart.menu" :close-on-content-click="false"
            :return-value.sync="datePickerStart.date" lazy transition="scale-transition" :offset-overflow="true"
            offset-y full-width max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <div class="border border-zt-dark-300 rounded px-2 pt-1 relative">
                <label class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8">{{
                  languages.date.from }}</label>
                <div>
                  <div>
                    <input data-vs-input="start-date" id="documents-search-documentcreatedsincefilter" v-on="on"
                      v-model="setInputStartDate" type="text" class="w-full outline-none py-2" />
                  </div>
                </div>
              </div>
            </template>
            <v-date-picker v-model="datePickerStart.date" @input="setInputStartPicker"
              @change="changePicker($event, 'publishDateFrom')" :locale="vuetifyLocale" no-title scrollable :max="maxStartDate">
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </div>
      </div>
      <div class="flex-1">
        <div class="pl-1">
          <v-menu ref="menuEnd" v-model="datePickerEnd.menu" :close-on-content-click="false"
            :return-value.sync="datePickerEnd.date" lazy transition="scale-transition" offset-y full-width
            :offset-overflow="true" max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <div class="border border-zt-dark-300 rounded px-2 pt-1 relative">
                <label class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8">{{ languages.date.to
                  }}</label>
                <div>
                  <div>
                    <input data-vs-input="end-date" id="documents-search-documentcreatedtofilter" v-on="on"
                      v-model="setInputEndDate" type="text" class="w-full outline-none py-2" />
                  </div>
                </div>
              </div>
            </template>
            <v-date-picker :max="nowDate" v-model="datePickerEnd.date" @input="setInputEndPicker"
              @change="changePicker($event, 'publishDateTo')" :locale="vuetifyLocale" no-title scrollable>
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </div>
      </div>
      <div v-show="isResetDatesVisible" class="px-2 inline-flex items-center">
        <button data-vs-button="clear-inputs" @click="clearDateInputs"
          class="text-zt-primary-200 text-zt-xl focus:outline-none">
          <zt-icon name="times-solid" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomChip from './CustomChip'
import MultiSelect from 'vue-multiselect'
import { filter, map } from 'lodash'
import moment from 'moment'
import { addFilters } from '../utils'
import addGTMClass from '@/utils/addGTMClass'
import { mapGetters } from 'vuex'

const formatInput = (date, format) => {
  return moment(date).format(format)
}

export default {
  name: 'SearchEformSection',
  inject: ['store', 'setFilters'],
  components: {
    MultiSelect,
    CustomChip
  },
  data() {
    return {
      gtmIds: [
        'documents-search-digitalformsfilter',
        'documents-search-documentcreatedsincefilter',
        'documents-search-documentcreatedtofilter'
      ],
      nowDate: new Date().toISOString().slice(0, 10),
      eformSelected: [],
      datePickerStart: {
        date: '',
        dateInverterStart: '',
        menu: false
      },
      datePickerEnd: {
        date: '',
        dateInverterEnd: '',
        menu: false
      },
      languages: {
        date: {
          from: this.$t("message.inicioComponent.createSince"), // 'Creación desde'
          to: this.$t("message.inicioComponent.createUntil") // 'Creación hasta'
        }
      }
    }
  },
  mounted() {
    addGTMClass(this.gtmIds)
  },
  computed: {
    ...mapGetters({
      locale: 'getLocale'
    }),
    eformOpts() {
      if (this.store.foldersItems.length > 0) {
        const eforms = filter(this.store.foldersItems, { type: 'eforms' })
        return eforms[0].childs
      }
      return []
    },
    setInputStartDate() {
      if (!this.datePickerStart.date) {
        return null
      }
      return formatInput(this.datePickerStart.date, 'DD/MM/YYYY')
    },
    setInputEndDate() {
      if (!this.datePickerEnd.date) {
        return null
      }
      return formatInput(this.datePickerEnd.date, 'DD/MM/YYYY')
    },
    maxStartDate() {
      if (this.datePickerEnd.date) {
        return this.datePickerEnd.date
      }

      return this.nowDate
    },
    isResetDatesVisible() {
      return !!this.datePickerStart.date || !!this.datePickerEnd.date
    },
    vuetifyLocale() {
      return this.locale === 'br' ? 'pt' : 'es'
    }
  },
  methods: {
    setEformSelected(value) {
      this.eformSelected = value
      this.setStoreFilter(['eform', map(this.eformSelected, 'id')])
    },
    setInputStartPicker() {
      this.$refs.menuStart.save(this.datePickerStart.date)
      this.datePickerStart.menu = false
    },
    setInputEndPicker() {
      this.$refs.menuEnd.save(this.datePickerEnd.date)
      this.datePickerEnd.menu = false
    },
    setStoreFilter(...args) {
      const { filters } = this.store
      const newFilters = addFilters({ ...filters }, ...args)
      this.setFilters(newFilters)
    },
    changePicker(value, key) {
      this.setStoreFilter([key, value])
    },
    clearDateInputs() {
      this.datePickerStart.date = ''
      this.datePickerEnd.date = ''
      this.setStoreFilter(['publishDateFrom', ''], ['publishDateTo', ''])
    }
  }
}
</script>
